import { withProps } from 'recompose'

export default withProps(({ items = []}) =>
  ({ contentBlock: items && items[0] && items[0].data }))
